import React from "react";

export class File extends React.Component {
    render() {
        return (
            <input
                type="file"
                id={this.props.name}
                name={this.props.name}
                accept={this.props.accept}
                disabled={this.props.disabled}
                files={this.props.files}
                hidden={this.props.invisible}
                multiple={this.props.multiple}
                required={this.props.required}
                value={this.props.value}
                onChange={this.props.onChange}
                onBlur={this.props.onBlur}
            />
        );
    }
}
